import SmoothScroll from 'smooth-scroll'
import Navigation from './lib/navigation'
import stickyContent from './lib/stickyContent'
import Accordion from './lib/accordion'
import Splide from '@splidejs/splide'

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if(toggle.href == '#'){
      return 0
    }else{
      const headerHeight = document.querySelector('.header') ?
        document.querySelector('.header').offsetHeight : 0;
      return headerHeight
    }
  }
})

Navigation('header-nav__btn', 'body')
Accordion()

stickyContent([['cta-recipe', 'map']])


// Splide
const options = {
  // perMove: 1,
  easing: 'linear',
  drag: true,
  pagination: false,
}

if(document.getElementById('topCarousel')) {
  const carouselOptions = {
    ...options,
    mediaQuery: 'min',
    type: 'loop',
    perPage: 2,
    perMove: 1,
    gap: '5px',
    arrows: false,
    speed: 250,
    interval: 2000,
    autoplay: true,
    easing: 'ease-out',
    autoWidth: true,
    padding: {left: '10%', right: '10%'},
    breakpoints: {
      600: {
        autoWidth: false,
        padding: {left: 0, right: '25%'}
      },
    },
  }
  new Splide( '#topCarousel', carouselOptions ).mount()
}

if(document.getElementById('topItems')) {
  const itemOptions = {
    ...options,
    mediaQuery: 'min',
    perPage: 1,
    gap: '20px',
    padding: {left: '40px', right: '40px'},
    arrows: false,
    focus: "center",
    breakpoints: {
      751: {
        destroy: true,
      },
      600: {
        perPage: 2,
        gap: '40px',
      },
    },
  }
  new Splide( '#topItems', itemOptions ).mount()
}

// map
const customMapStyle = [
  {
    stylers: [
      { hue: '' },
      { saturation: -100 },
      { lightness: 0 },
      { visibility: 'undefined' },
      { invert_lightness: false },
      { gamma: 0.5 }
    ]
  },
  {
    featureType: "all",
    elementType: "geometry.stroke",
    stylers: [
      { color: "#000000" }
    ]
  },
  {
    featureType: "all",
    elementType: "geometry.fill",
    stylers: [
      { color: "#FFFFFF" }
    ]
  },
  {
    featureType: "building",
    elementType: "geometry.stroke",
    stylers: [
      { color: "#aaaaaa" }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      { color: "#000000" }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      { color: "#000000" }
    ]
  },
  {
    featureType: "poi.medical",
    elementType: "geometry.fill",
    stylers: [
      { color: "#3A3A3A" }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [
      { color: "#3A3A3A" }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      { color: "#000000" }
    ]
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      { color: "#000000" }
    ]
  },
];

const initMap = () =>  {
  const latLng = new google.maps.LatLng(33.8800205,130.8668849);
  const mapOptions = {
    center: latLng,
    zoom: 17,
    styles: customMapStyle,
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    scaleControl: false,
    fullscreenControl: false,
    clickableIcons: false
  };

  const map = new google.maps.Map(document.getElementById('map'), mapOptions);
  const marker = new google.maps.Marker({
    position: latLng,
    map: map
  });
}

window.initMap = initMap;
